import { Route } from '@angular/router';
import { pageGuard } from './guards/page.guard';

export const appRoutes: Route[] = [
  { path: '', redirectTo: '/purchase', pathMatch: 'full' }, // redirect to `purchase`
  {
    path: 'purchase',
    loadComponent: () =>
      import('./components/giftcard/giftcard.component').then(
        (m) => m.GiftcardComponent,
      ),
  },
  {
    path: 'payment',
    canMatch: [pageGuard],
    loadComponent: () =>
      import('./components/payment/payment.component').then(
        (m) => m.PaymentComponent,
      ),
  },
  {
    path: 'thank-you/:id',
    loadComponent: () =>
      import('./components/thank-you/thank-you.component').then(
        (m) => m.ThankYouComponent,
      ),
  },
  { path: '**', redirectTo: '/purchase' },
];
